export default __webpack_public_path__ + "static/media/ShopezDefult.7f5691f8.svg";